import { h } from 'vue';
import BaseIconExpandMore from '@/components/BaseIconExpandMore.vue';
import BaseIconTrash from '@/components/BaseIconTrash.vue';
import BaseIconViewMenuOutline from '@/components/BaseIconViewMenuOutline.vue';

const IconComponents = {
  BaseIconExpandMore,
  BaseIconTrash,
  BaseIconViewMenuOutline,
};

export const icons = { component: props => h(IconComponents[props.icon]) };
